<template lang="pug">
    main.nosotras.contenedor.pt110      
      folleto1
      br 
      br
      folleto2


</template>

<script>
import folleto1 from '@/components/folleto/folleto1.vue'
import folleto2 from '@/components/folleto/folleto2.vue'

  export default {
      name: 'Folleto',
      components: {
        folleto1,
        folleto2
      }
    }
</script>
